var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { noSpaces } from 'services/helperFunctions/handleRegex';
import { ErrorAdornment } from './ErrorAdornment';
export var getModelCodeInputProps = function (value, maxLength, sx) { return (__assign({ endAdornment: (_jsx(ErrorAdornment, { errors: [
            { condition: !noSpaces(value), message: 'No spaces allowed' },
            { condition: value.length > maxLength, message: "Must be ".concat(maxLength, " characters or fewer") },
        ] })) }, (sx && { sx: sx }))); };
